import styled from "styled-components";

export const Container = styled.div`
  width: 420px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 60px;
  grid-column-gap: ${({ theme }) => theme.spacing * 2}px;
  .input-container {
    padding: ${({ theme }) => theme.spacing * 2}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.spacing * 2}px;
    background-color: ${({ theme }) => theme.colors.shades[0]};
    border-radius: ${({ theme }) => theme.radius}px;
    padding: ${({ theme }) => theme.spacing * 2}px;
    box-shadow: ${({ theme }) => theme.boxShadow};
    .clear {
      width: 24px;
      height: 24px;
      padding: 0;
      border: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: unset;
      > svg {
        width: 20px;
        height: 20px;
        > g, path {
          fill: ${({ theme }) => theme.colors.gray[400]};
        }
      }
    }
    > button {
      width: 44px;
      height: 44px;
    }
    > input {
      width: 100%;
      height: 100%;
      border: none;
      font-size: 14px;
      outline: none;
      &::placeholder {
        color: ${({ theme }) => theme.colors.gray[400]};
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    grid-template-columns: 1fr 60px;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    .input-container {
      width: 100%;
    }
  }
`;

export const SearchButton = styled.button`
  min-width: 44px;
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: ${({ theme }) => theme.radius}px;
  background-color: ${({ theme }) => theme.colors.secondary[900]};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.shades[0]};
    }
  }
`;

export const FiltersButton = styled.button`
  min-width: 60px;
  width: 60px;
  height: 60px;
  padding: 0;
  border-radius: ${({ theme }) => theme.radius}px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.boxShadow};
  position: relative;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.gray[900]};
    }
  }
`;

export const Badge = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary[500]};
  position: absolute;
  top: -4px;
  right: -4px;
`;
